import { createClient } from '@supabase/supabase-js';

// CRA inlines these at build time, so only ever put the *publishable* key
// here (sb_publishable_..., listed as "anon public" on older projects) -- it
// is public by design and RLS is what actually protects the data.
const url = process.env.REACT_APP_SUPABASE_URL;
const publishableKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

if (!url || !publishableKey) {
  throw new Error(
    'Missing REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_PUBLISHABLE_KEY. ' +
      'Copy .env.example to .env.local and fill it in, then restart the dev server.',
  );
}

export const supabase = createClient(url, publishableKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // The apply funnel verifies a typed-in code; there is never a token in
    // the URL to pick up, and leaving this on makes the router fight the
    // hash fragment.
    detectSessionInUrl: false,
  },
});
